<template>
  <div class="page">
    <!-- 顶部头图与标题（左对齐、白底徽章） -->
    <header class="header">
      <div class="header-title">您的健康解决方案</div>
      <div class="badge badge-white">肺脾气虚证</div>
    </header>

    <main class="container">
      <!-- 饮食调养（图标在上，标题在下；右侧为“原则”气泡） -->
      <section class="card">
        <div class="card-hd">
          <div class="hd-left">
            <img class="icon" :src="icons.diet" alt="饮食图标" />
            <div class="card-title">饮食调养</div>
          </div>
          <div class="rule-bubble">
            原则：多吃性平、味甘，具有补气作用的食物，兼顾五谷杂粮、蔬菜水果，少油少盐，易于消化吸收。
          </div>
        </div>

        <div class="card-bd">
          <div class="panel panel-aqua">
            <div class="panel-title">推荐食物</div>
            <div class="panel-text">
              粮食类：小米、粳米、糯米、薏米、燕麦、山药、土豆、红薯。<br />
              肉类：牛肉、鸡肉、猪肚、鱼（鲈鱼、鲫鱼等）。<br />
              豆类及其制品：黄豆、豆腐、豆浆。<br />
              其他：红枣、木耳、蜂蜜、黑芝麻、栗子、莲子、枸杞。
            </div>
          </div>

          <div class="panel panel-peach">
            <div class="panel-title">食疗方案</div>
            <div class="panel-text">
              黄芪莲子粥：黄芪30g煎水取汁，加入山药片50g、莲子10g、粳米100g煮粥。<br />
              山药核桃大枣茶：山药片15g，核桃仁10g，红枣3枚，加水适量，小火煮20分钟，温服。<br />
              上述两法可交替食用，健脾益气，适合日常调养。
            </div>
          </div>

          <div class="panel panel-pink panel-warning">
            <div class="panel-title">饮食禁忌</div>
            <div class="panel-text">
              少吃辛辣、油腻、刺激类以及难消化的食物（如烧烤、肥肉、油炸食品等），以免损伤脾胃。
            </div>
            <img class="warn" :src="icons.warn" alt="!" />
          </div>
        </div>
      </section>

      <!-- 运动保健（图标在上，标题在下；右侧为“原则”气泡） -->
      <section class="card">
        <div class="card-hd">
          <div class="hd-left">
            <img class="icon" :src="icons.sport" alt="运动图标" />
            <div class="card-title">运动保健</div>
          </div>
          <div class="rule-bubble">
            原则：选择缓和的、低强度的运动，持之以恒，循序渐进。切忌高强度或出汗过多，容易“气耗”。
          </div>
        </div>

        <div class="card-bd">
          <div class="sub-title">推荐运动</div>
          <div class="tags">
            <span class="tag">太极拳</span>
            <span class="tag">八段锦</span>
            <span class="tag">五禽戏</span>
            <span class="tag">散步</span>
            <span class="tag">慢跑</span>
            <span class="tag">瑜伽</span>
          </div>
          <div class="note">注：运动前后少许做热身，出汗即可，不要大汗淋漓。</div>
        </div>
      </section>

      <!-- 情志起居调养（图标与标题左右排列） -->
      <section class="card">
        <div class="card-hd card-hd--no-bubble">
          <div class="hd-left hd-left--row">
            <img class="icon" :src="icons.emotion" alt="情志图标" />
            <div class="card-title">情志起居调养</div>
          </div>
        </div>

        <div class="card-bd">
          <div class="panel panel-blue">
            <div class="panel-title">情志调养</div>
            <div class="panel-text">
              心态平和：保持乐观开朗、积极向上的心态，努力做到“恬惔虚无，精神内守”。<br />
              舒畅情绪：及时排解不良情绪，避免狂喜、暴怒、忧思、悲愁、恐惧等过度情志刺激。
            </div>
          </div>

          <div class="panel panel-lavender">
            <div class="panel-title">起居调养</div>
            <div class="panel-text">
              规律作息：顺应四时，起居有常。保证充足的睡眠，避免熬夜。<br />
              避免过劳：无论是体力劳动还是脑力劳动，都不要过度透支。
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'HealthSolutionFixedV4',
  data() {
    return {
      icons: { diet: '', sport: '', emotion: '', warn: '' }
    };
  }
};
</script>

<style scoped>
/* 页面使用 padding 控制左右留白 */
.page {
  background: linear-gradient(180deg, #f2c7a5 0%, #e8b88f 40%, #e1ac84 100%);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 12px 14px 18px;
  box-sizing: border-box;
}

/* 顶部：左对齐、白底徽章 */
.header { margin-bottom: 8px; }
.header-title {
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
  text-align: left;
  text-shadow: 0 1px 2px rgba(0,0,0,0.12);
  margin-bottom: 6px;
}
.badge {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 12px;
}
.badge-white {
  background: #ffffff;
  color: #8a5b2a;
  border: 1px solid rgba(255,255,255,0.8);
}

/* 主体容器 */
.container {
  width: 100%;
  display: grid;
  grid-auto-rows: min-content;
  gap: 10px;
  box-sizing: border-box;
}

/* 卡片 */
.card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 18px rgba(128, 67, 26, 0.12);
  border: 1px solid rgba(255,255,255,0.7);
  overflow: hidden;
}

/* 头部（默认：图标上、标题下；右侧为“原则”） */
.card-hd {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 12px 6px;
  gap: 8px;
}
.hd-left {
  display: flex;
  flex-direction: column; /* 默认上下 */
  align-items: flex-start;
  gap: 6px;
}
.icon {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: #ffeae3; /* 占位色 */
  object-fit: cover;
}
.card-title {
  color: #2f2f2f;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
}

/* “原则”备注气泡 */
.rule-bubble {
  flex: 1;
  margin-left: 8px;
  background: #f5f5f7;
  border: 1px solid #eeeeee;
  color: #6b6b6b;
  font-size: 12px;
  line-height: 1.6;
  border-radius: 8px;
  padding: 8px 10px;
}

/* 情志起居调养：左右排列、无气泡时靠左 */
.hd-left--row {
  flex-direction: row;          /* 左右排列 */
  align-items: center;
  gap: 8px;
}
.card-hd--no-bubble {
  justify-content: flex-start;  /* 无右侧备注时靠左 */
  padding-bottom: 8px;
}

/* 正文 */
.card-bd { padding: 8px 12px 12px; }

/* 面板与副标题色系 */
.panel {
  position: relative;
  border-radius: 10px;
  padding: 10px 12px;
  border: 1px solid transparent;
}
.panel + .panel { margin-top: 8px; }

.panel-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}
.panel-text {
  font-size: 13px;
  line-height: 1.6;
  color: #4a4a4a;
}

.panel-aqua { background: #e9fbff; border-color: #d6f4fb; }
.panel-aqua .panel-title { color: #1aa3b0; }

.panel-peach { background: #fff3e5; border-color: #ffe1c4; }
.panel-peach .panel-title { color: #e48a3a; }

.panel-pink { background: #fff2f4; border-color: #ffdbe0; }
.panel-pink .panel-title { color: #e15a6c; }

.panel-blue { background: #ecf7ff; border-color: #d8ecff; }
.panel-blue .panel-title { color: #3aa1ff; }

.panel-lavender { background: #f4efff; border-color: #e4ddff; }
.panel-lavender .panel-title { color: #7f69d9; }

/* 警示图标 */
.panel-warning .warn {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 18px;
  height: 18px;
  background: #ff6b6b;
  border-radius: 50%;
  opacity: 0.85;
}

/* 运动标签与注释 */
.sub-title {
  font-size: 13px;
  font-weight: 600;
  color: #3a3a3a;
  margin: 2px 0 8px;
}
.tags { display: flex; flex-wrap: wrap; gap: 8px; }
.tag {
  font-size: 12px;
  color: #ffffff;
  background: #1db7aa;
  border-radius: 999px;
  padding: 6px 12px;
  box-shadow: 0 2px 0 rgba(0,0,0,0.04) inset;
}
.note { margin-top: 8px; font-size: 12px; color: #7a7a7a; }
</style>
